<template>
  <div class="form-group">
    <label v-if="label">
      {{ label }}
      <span v-if="required" style="color: red">*</span>

    </label>

    <input
      type="text"
      class="form-control"
      :value="localValue"
      :placeholder="placeholder"
      @input="onInput"
      @blur="onBlur"
    >

    <small v-if="hint" class="form-text text-muted">
      {{ hint }}
    </small>

    <small v-if="error" class="form-text text-danger">
      {{ error }}
    </small>
  </div>
</template>

<script>
import { normalizeIban, validateIban } from '@/helpers/iban'

export default {
  name: 'IbanInput',
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: 'FR76 XXXX XXXX XXXX XXXX XXXX XXX'
    },
    autoFormat: {
      type: Boolean,
      default: true   // met des espaces tous les 4 caractères
    },
    hint: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      error: ''
    }
  },
  computed: {
    localValue () {
      return this.value
    },
    // exposé au parent si tu veux tester directement
    isValid () {
      return !this.error && (!this.required || !!normalizeIban(this.value))
    }
  },
  watch: {
    value () {
      // si le parent change la valeur, on revalide
      this.validate()
    }
  },
  methods: {
    onInput (evt) {
      let val = evt.target.value

      if (this.autoFormat) {
        const norm = normalizeIban(val)
        // formattage avec espaces tous les 4 caractères
        val = norm.replace(/(.{4})/g, '$1 ').trim()
      }

      this.$emit('input', val)
      this.$nextTick(() => {
        this.validate(false) // pas obligatoire d’afficher tout de suite l’erreur
      })
    },
    onBlur () {
      this.validate(true)    // sur blur on montre l’erreur si besoin
    },
    validate (showError = true) {
      const raw = this.value

      const norm = normalizeIban(raw)
      if (!norm) {
        if (this.required) {
          if (showError) {
            this.error = this.$t
              ? this.$t('mandate.iban_required')
              : 'IBAN requis'
          }
          return false
        } else {
          this.error = ''
          return true
        }
      }

      const result = validateIban(raw)

      if (!result.valid) {
        if (showError) {
          let msg = ''

          if (this.$t) {
            switch (result.code) {
              case 'empty':
                msg = this.$t('mandate.iban_required')
                break
              case 'invalid_chars':
                msg = this.$t('mandate.iban_invalid_chars')
                break
              case 'too_short':
                msg = this.$t('mandate.iban_too_short')
                break
              case 'country_not_supported':
                msg = this.$t('mandate.iban_country_not_supported', {
                  country: result.country || ''
                })
                break
              case 'wrong_length':
                msg = this.$t('mandate.iban_wrong_length', {
                  country: result.country || ''
                })
                break
              case 'checksum':
                msg = this.$t('mandate.iban_invalid_checksum')
                break
              default:
                msg = this.$t('mandate.iban_invalid_generic') || 'IBAN invalide'
            }
          } else {
            // fallback sans i18n
            msg = 'IBAN invalide'
          }

          this.error = msg
        }
        return false
      }

      this.error = ''
      return true

    }
  }
}
</script>
